const state = {
  stand: []
}

const getters = {
  allStand (state) {
    return this.stand
  }
}

const actions = {
  setStand (context, params) {
    context.commit('SETSTAND', params)
  }
}

const mutations = {
  SETSTAND (state, params) {
    // var insertStand = JSON.parse(JSON.stringify(params))
    // state.stand.push(insertStand)
    state.stand = params
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stand.js